/* ==========================================================================
   Hamza Selim theme — storefront scripts
   No dependencies. Everything is delegated from document where possible so
   sections re-rendered by the theme editor or AJAX keep working.
   ========================================================================== */
(function () {
  'use strict';

  var T = window.theme || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var parser = new DOMParser();
  var parseHTML = function (html) { return parser.parseFromString(html, 'text/html'); };
  var rootUrl = (T.routes.root || '/').replace(/\/$/, '');

  /* ---------- Helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    format = format || T.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var parts = (number / 100).toFixed(precision).split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }

    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = withDelimiters(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = withDelimiters(cents, 2, ' ', '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  var store = {
    get: function (key, fallback) {
      try {
        var v = JSON.parse(window.localStorage.getItem(key));
        return v === null ? fallback : v;
      } catch (e) { return fallback; }
    },
    set: function (key, value) {
      try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage unavailable */ }
    }
  };

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  var toastTimer;
  function toast(message) {
    var el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3000);
  }

  function fetchText(url, options) {
    return fetch(url, options).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.text();
    });
  }

  /* ---------- Overlay, drawers, modals ---------- */
  var overlay = $('[data-overlay]');

  function lockScroll(lock) { document.body.classList.toggle('is-locked', lock); }

  var Drawers = {
    active: null,
    lastFocus: null,
    open: function (name) {
      var drawer = $('[data-drawer="' + name + '"]');
      if (!drawer) return false;
      if (this.active && this.active !== drawer) this.close(true);
      this.lastFocus = document.activeElement;
      this.show(drawer);
      if (overlay) overlay.classList.add('is-visible');
      lockScroll(true);
      var focusTarget = $('[data-predictive-search-input]', drawer) || $('[data-drawer-close]', drawer);
      setTimeout(function () { if (focusTarget) focusTarget.focus({ preventScroll: true }); }, 60);
      return true;
    },
    show: function (drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      var section = drawer.closest('.shopify-section');
      if (section) section.classList.add('is-raised');
      this.active = drawer;
    },
    close: function (keepOverlay) {
      var drawer = this.active;
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      var section = drawer.closest('.shopify-section');
      if (section) {
        setTimeout(function () {
          if (!drawer.classList.contains('is-open')) section.classList.remove('is-raised');
        }, 360);
      }
      this.active = null;
      if (!keepOverlay) {
        if (overlay) overlay.classList.remove('is-visible');
        lockScroll(false);
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus({ preventScroll: true });
      }
    }
  };

  var Modal = {
    active: null,
    open: function (modal) {
      if (Drawers.active) Drawers.close();
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      this.active = modal;
    },
    close: function () {
      if (!this.active) return;
      this.active.classList.remove('is-open');
      this.active.setAttribute('aria-hidden', 'true');
      this.active = null;
      if (!Drawers.active) lockScroll(false);
    }
  };

  /* ---------- Cart ---------- */
  var Cart = {
    updateCount: function (count) {
      $$('[data-cart-count-bubble]').forEach(function (el) { el.textContent = count; });
    },
    renderDrawer: function (html) {
      var current = $('#CartDrawerInner');
      if (!current) return Promise.resolve();
      var promise = html
        ? Promise.resolve(html)
        : fetchText(T.routes.cart + '?section_id=cart-drawer');
      return promise.then(function (markup) {
        var next = $('#CartDrawerInner', parseHTML(markup));
        if (!next) return;
        current.replaceWith(next);
        Cart.updateCount(next.getAttribute('data-cart-count'));
        initSliders(next);
      });
    },
    refresh: function () {
      if ($('[data-cart-page]')) { window.location.reload(); return Promise.resolve(); }
      if ($('#CartDrawerInner')) return this.renderDrawer();
      return fetch(T.routes.cart + '.js').then(function (r) { return r.json(); }).then(function (c) { Cart.updateCount(c.item_count); });
    },
    add: function (form) {
      var button = $('[type="submit"]', form);
      var scope = form.closest('[data-product]');
      var errorEl = scope ? $('[data-form-error]', scope) : null;
      var data = new FormData(form);
      if (!data.get('selling_plan')) data.delete('selling_plan');
      var useDrawer = T.cartType === 'drawer' && $('#CartDrawerInner');
      if (useDrawer) {
        data.append('sections', 'cart-drawer');
        data.append('sections_url', window.location.pathname);
      }
      if (button) button.classList.add('is-loading');

      return fetch(T.routes.cartAdd, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: data
      })
        .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
        .then(function (res) {
          if (!res.ok || res.json.status) throw new Error(res.json.description || res.json.message || T.strings.error);
          if (errorEl) errorEl.hidden = true;
          if (!useDrawer) { window.location.href = T.routes.cart; return; }
          return Cart.renderDrawer(res.json.sections && res.json.sections['cart-drawer']).then(function () {
            Modal.close();
            Drawers.open('cart');
          });
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          else toast(err.message);
        })
        .finally(function () { if (button) button.classList.remove('is-loading'); });
    },
    change: function (key, quantity) {
      var item = $('[data-cart-item="' + key + '"]');
      if (item) item.classList.add('is-loading');
      var body = { id: key, quantity: Math.max(0, parseInt(quantity, 10) || 0) };
      var onPage = !!$('[data-cart-page]');
      if (!onPage) body.sections = 'cart-drawer';
      return fetch(T.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (json.status) throw new Error(json.description || json.message);
          if (onPage) { window.location.reload(); return; }
          Cart.updateCount(json.item_count);
          return Cart.renderDrawer(json.sections && json.sections['cart-drawer']);
        })
        .catch(function (err) {
          toast(err.message || T.strings.error);
          if (item) item.classList.remove('is-loading');
        });
    },
    saveNote: function (note) {
      return fetch(T.routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note })
      });
    },
    applyCoupon: function (code) {
      code = (code || '').trim();
      if (!code) return Promise.resolve();
      store.set('hs-coupon', code);
      return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .catch(function () { /* the code is still applied on the checkout form below */ })
        .then(function () {
          toast(T.strings.couponSaved);
          return Cart.refresh();
        });
    }
  };

  /* ---------- Product form ---------- */
  var initializedProducts = typeof WeakSet !== 'undefined' ? new WeakSet() : null;

  function ProductForm(root) {
    this.root = root;
    var json = $('[data-product-json]', root);
    if (!json) return;
    this.product = JSON.parse(json.textContent);
    this.form = document.getElementById(root.getAttribute('data-form-id'));
    this.updateUrl = root.getAttribute('data-update-url') === 'true';
    this.variant = this.currentVariant();

    var self = this;
    root.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index]')) self.onOptionChange();
      if (e.target.matches('[data-purchase-type], [data-selling-plan-select]')) self.updatePurchase();
    });

    if (new URLSearchParams(window.location.search).get('purchase') === 'subscribe') {
      var sub = $('[data-purchase-type][value="subscription"]', root);
      if (sub) sub.checked = true;
    }
    this.updatePurchase();
    this.updateAvailability();
    this.initSticky();
  }

  ProductForm.prototype.currentVariant = function () {
    var input = this.form ? $('[name="id"]', this.form) : null;
    var id = input ? Number(input.value) : 0;
    var variants = this.product.variants;
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return variants[0];
  };

  ProductForm.prototype.selectedOptions = function () {
    var options = [];
    $$('[data-option-index]', this.root).forEach(function (el) {
      var i = Number(el.getAttribute('data-option-index'));
      if (el.tagName === 'SELECT') options[i] = el.value;
      else if (el.checked) options[i] = el.value;
    });
    return options;
  };

  ProductForm.prototype.findVariant = function (options) {
    return this.product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === options[i]; });
    })[0] || null;
  };

  ProductForm.prototype.onOptionChange = function () {
    var options = this.selectedOptions();
    var root = this.root;
    options.forEach(function (value, i) {
      var label = $('[data-option-value="' + i + '"]', root);
      if (label) label.textContent = value;
    });

    var variant = this.findVariant(options);
    this.variant = variant;
    this.updateAvailability();

    if (!variant) {
      this.setButton(false, T.strings.unavailable);
      return;
    }

    $$('[data-variant-input]', root).forEach(function (input) {
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    this.setButton(variant.available, variant.available ? T.strings.addToCart : T.strings.soldOut);
    if (variant.featured_media) Gallery.goToMedia(root, variant.featured_media);
    if (this.updateUrl) window.history.replaceState({}, '', this.product.url + '?variant=' + variant.id);
    this.updatePurchase();
  };

  ProductForm.prototype.updateAvailability = function () {
    var self = this;
    var selected = this.selectedOptions();
    $$('.pill input[data-option-index]', this.root).forEach(function (input) {
      var index = Number(input.getAttribute('data-option-index'));
      var test = selected.slice();
      test[index] = input.value;
      var match = self.findVariant(test);
      input.closest('.pill').classList.toggle('is-unavailable', !match || !match.available);
    });
  };

  ProductForm.prototype.selectedPlan = function () {
    var select = $('[data-selling-plan-select]', this.root);
    if (!select) return null;
    var sub = $('[data-purchase-type][value="subscription"]', this.root);
    var oneTime = $('[data-purchase-type][value="onetime"]', this.root);
    if ((sub && sub.checked) || !oneTime) return select.value;
    return null;
  };

  ProductForm.prototype.allocation = function (variant, planId) {
    if (!variant || !planId) return null;
    return variant.selling_plan_allocations.filter(function (a) { return String(a.selling_plan_id) === String(planId); })[0] || null;
  };

  ProductForm.prototype.updatePurchase = function () {
    $$('[data-purchase-option]', this.root).forEach(function (option) {
      var radio = $('[data-purchase-type]', option);
      option.classList.toggle('is-selected', !!(radio && radio.checked));
    });
    var input = this.form ? $('[data-selling-plan-input]', this.form) : null;
    if (input) input.value = this.selectedPlan() || '';
    this.updatePrice();
  };

  ProductForm.prototype.updatePrice = function () {
    var v = this.variant;
    if (!v) return;
    var planId = this.selectedPlan();
    var allocation = this.allocation(v, planId);
    var price = v.price;
    var compare = v.compare_at_price;
    if (allocation) {
      price = allocation.price;
      compare = allocation.compare_at_price > allocation.price ? allocation.compare_at_price : (v.price > allocation.price ? v.price : 0);
    }

    var priceEl = $('[data-price]', this.root);
    if (priceEl) {
      var current = $('[data-current-price]', priceEl);
      var compareEl = $('[data-compare-price]', priceEl);
      if (current) current.textContent = formatMoney(price);
      if (compareEl) {
        compareEl.textContent = compare > price ? formatMoney(compare) : '';
        compareEl.hidden = !(compare > price);
      }
      priceEl.classList.toggle('price--on-sale', compare > price);
    }

    var oneTimePrice = $('[data-onetime-price]', this.root);
    if (oneTimePrice) oneTimePrice.textContent = formatMoney(v.price);
    var subPrice = $('[data-subscription-price]', this.root);
    if (subPrice) {
      var select = $('[data-selling-plan-select]', this.root);
      var subAllocation = this.allocation(v, select ? select.value : null);
      subPrice.textContent = subAllocation ? formatMoney(subAllocation.price) : '';
    }
    var stickyPrice = $('[data-sticky-price]', this.root);
    if (stickyPrice) stickyPrice.textContent = formatMoney(price);
  };

  ProductForm.prototype.setButton = function (enabled, label) {
    var buttons = [];
    if (this.form) buttons = buttons.concat($$('[data-add-button]', this.form));
    var sticky = $('[data-sticky-add]', this.root);
    if (sticky) buttons.push(sticky);
    buttons.forEach(function (btn) {
      btn.disabled = !enabled;
      var text = $('[data-add-label]', btn) || btn;
      text.textContent = label;
    });
  };

  ProductForm.prototype.initSticky = function () {
    var bar = $('[data-sticky-atc]', this.root);
    if (!bar || !this.form || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    });
    observer.observe(this.form);
  };

  function initProducts(scope) {
    $$('[data-product]', scope).forEach(function (root) {
      if (initializedProducts) {
        if (initializedProducts.has(root)) return;
        initializedProducts.add(root);
      }
      new ProductForm(root);
    });
  }

  /* ---------- Gallery & lightbox ---------- */
  var Gallery = {
    init: function (scope) {
      $$('[data-gallery]', scope).forEach(function (gallery) {
        if (gallery.__init) return;
        gallery.__init = true;
        var track = $('[data-gallery-track]', gallery);
        if (!track) return;
        var start = Number(gallery.getAttribute('data-start')) || 0;
        if (start) {
          track.style.scrollBehavior = 'auto';
          track.scrollLeft = start * track.clientWidth;
          track.style.scrollBehavior = '';
        }
        track.addEventListener('scroll', debounce(function () { Gallery.sync(gallery); }, 60), { passive: true });
      });
    },
    index: function (gallery) {
      var track = $('[data-gallery-track]', gallery);
      return track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0;
    },
    sync: function (gallery) {
      var i = this.index(gallery);
      $$('[data-gallery-thumb]', gallery).forEach(function (thumb, n) {
        thumb.classList.toggle('is-active', n === i);
        if (n === i && thumb.scrollIntoView && thumb.parentElement.scrollWidth > thumb.parentElement.clientWidth) {
          thumb.parentElement.scrollTo({ left: thumb.offsetLeft - thumb.parentElement.clientWidth / 2 + thumb.clientWidth / 2, behavior: 'smooth' });
        }
      });
      $$('.gallery__dot', gallery).forEach(function (dot, n) { dot.classList.toggle('is-active', n === i); });
    },
    goTo: function (gallery, i) {
      var track = $('[data-gallery-track]', gallery);
      if (!track) return;
      var count = track.children.length;
      i = (i + count) % count;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    },
    goToMedia: function (root, mediaId) {
      var slide = $('[data-media-id="' + mediaId + '"]', root);
      if (!slide) return;
      var gallery = slide.closest('[data-gallery]');
      this.goTo(gallery, Number(slide.getAttribute('data-index')));
    }
  };

  var Lightbox = {
    el: $('#Lightbox'),
    images: [],
    index: 0,
    open: function (gallery, index) {
      if (!this.el) return;
      var data = $('[data-lightbox-images]', gallery);
      this.images = data ? JSON.parse(data.textContent) : [];
      this.show(index);
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      lockScroll(true);
    },
    show: function (index) {
      var count = this.images.length;
      if (!count) return;
      for (var n = 0; n < count; n++) {
        var i = ((index + n) % count + count) % count;
        if (this.images[i]) { this.index = i; break; }
      }
      $('.lightbox__image', this.el).src = this.images[this.index];
      var single = this.images.filter(Boolean).length < 2;
      $$('.lightbox__nav', this.el).forEach(function (b) { b.hidden = single; });
    },
    step: function (dir) {
      var count = this.images.length;
      var i = this.index;
      for (var n = 0; n < count; n++) {
        i = ((i + dir) % count + count) % count;
        if (this.images[i]) break;
      }
      this.show(i);
    },
    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      if (!Drawers.active && !Modal.active) lockScroll(false);
    }
  };

  /* ---------- Generic slider ---------- */
  function initSliders(scope) {
    $$('[data-slider]', scope).forEach(function (slider) {
      var track = $('[data-slider-track]', slider);
      if (!track) return;
      var prev = $('[data-slider-prev]', slider);
      var next = $('[data-slider-next]', slider);
      var dots = $('[data-slider-dots]', slider);

      function pages() { return Math.max(1, Math.round(track.scrollWidth / Math.max(1, track.clientWidth))); }

      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        slider.classList.toggle('is-static', max <= 0);
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (dots) {
          var count = pages();
          if (dots.children.length !== count) {
            dots.innerHTML = '';
            for (var i = 0; i < count; i++) {
              var b = document.createElement('button');
              b.type = 'button';
              b.className = 'slider__dot';
              b.setAttribute('aria-label', String(i + 1));
              b.setAttribute('data-slider-dot', i);
              dots.appendChild(b);
            }
          }
          var active = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          $$('.slider__dot', dots).forEach(function (d, n) { d.classList.toggle('is-active', n === active); });
        }
      }

      if (!slider.__init) {
        slider.__init = true;
        track.addEventListener('scroll', debounce(update, 50), { passive: true });
        window.addEventListener('resize', debounce(update, 150));
      }
      slider.__update = update;
      update();
    });
  }

  function slideBy(slider, dir) {
    var track = $('[data-slider-track]', slider);
    var slide = track && track.firstElementChild;
    if (!slide) return;
    var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    var step = slide.getBoundingClientRect().width + gap;
    var perView = Math.max(1, Math.floor((track.clientWidth + gap) / step));
    track.scrollBy({ left: dir * step * perView, behavior: 'smooth' });
  }

  /* ---------- Quick view ---------- */
  function openQuickView(url) {
    var modal = $('#QuickView');
    if (!modal) { window.location.href = url; return; }
    var content = $('[data-quick-view-content]', modal);
    content.innerHTML = '';
    content.classList.add('is-loading');
    Modal.open(modal);

    var target = new URL(url, window.location.origin);
    target.searchParams.set('section_id', 'quick-view');
    fetchText(target.toString())
      .then(function (html) {
        var view = $('.quick-view', parseHTML(html));
        content.classList.remove('is-loading');
        if (!view) throw new Error('empty');
        content.appendChild(view);
        initProducts(content);
        Gallery.init(content);
        Wishlist.sync();
      })
      .catch(function () { window.location.href = url; });
  }

  /* ---------- Wishlist ---------- */
  var Wishlist = {
    key: 'hs-wishlist',
    list: function () { return store.get(this.key, []); },
    toggle: function (handle) {
      var list = this.list();
      var i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1);
      else list.unshift(handle);
      store.set(this.key, list.slice(0, 60));
      this.sync();
      var grid = $('[data-wishlist-grid]');
      if (grid && i > -1) {
        var card = $('[data-handle="' + handle + '"]', grid);
        if (card) card.closest('li').remove();
        if (!grid.children.length) $('[data-wishlist-empty]').hidden = false;
      }
    },
    sync: function () {
      var list = this.list();
      $$('[data-wishlist-toggle]').forEach(function (btn) {
        var on = list.indexOf(btn.getAttribute('data-wishlist-toggle')) > -1;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var label = $('[data-wishlist-label]', btn);
        if (label) label.textContent = on ? T.strings.inWishlist : T.strings.addToWishlist;
        else btn.setAttribute('aria-label', on ? T.strings.inWishlist : T.strings.addToWishlist);
      });
      $$('[data-wishlist-count]').forEach(function (el) {
        el.textContent = list.length;
        el.hidden = list.length === 0;
      });
    },
    renderPage: function () {
      var grid = $('[data-wishlist-grid]');
      if (!grid) return;
      var list = this.list();
      var empty = $('[data-wishlist-empty]');
      if (!list.length) { empty.hidden = false; return; }
      loadCards(list).then(function (cards) {
        cards.forEach(function (card) {
          var li = document.createElement('li');
          li.className = 'grid__item';
          li.appendChild(card);
          grid.appendChild(li);
        });
        if (!cards.length) empty.hidden = false;
        Wishlist.sync();
      });
    }
  };

  function loadCards(handles) {
    return Promise.all(handles.map(function (handle) {
      return fetchText(rootUrl + '/products/' + encodeURIComponent(handle) + '?section_id=product-card-ajax')
        .then(function (html) {
          var card = $('.ajax-card > *', parseHTML(html));
          return card || null;
        })
        .catch(function () { return null; });
    })).then(function (cards) { return cards.filter(Boolean); });
  }

  /* ---------- Recently viewed & recommendations ---------- */
  var RECENT_KEY = 'hs-recent';

  function trackRecentlyViewed() {
    var product = $('[data-product][data-product-handle]');
    if (!product) return;
    var handle = product.getAttribute('data-product-handle');
    var list = store.get(RECENT_KEY, []).filter(function (h) { return h !== handle; });
    list.unshift(handle);
    store.set(RECENT_KEY, list.slice(0, 16));
  }

  function initProductRecs(scope) {
    $$('[data-product-recs]', scope).forEach(function (section) {
      if (section.__init) return;
      section.__init = true;
      var current = section.getAttribute('data-current-handle');
      var relatedTarget = $('[data-recs-target]', section);
      var recentTarget = $('[data-recently-viewed]', section);
      var jobs = [];

      if (relatedTarget) {
        jobs.push(fetchText(section.getAttribute('data-url')).then(function (html) {
          var fresh = $('[data-recs-target]', parseHTML(html));
          if (fresh && fresh.children.length) {
            relatedTarget.innerHTML = fresh.innerHTML;
            return true;
          }
          return false;
        }).catch(function () { return false; }));
      } else jobs.push(Promise.resolve(false));

      if (recentTarget) {
        var limit = Number(recentTarget.getAttribute('data-limit')) || 8;
        var handles = store.get(RECENT_KEY, []).filter(function (h) { return h !== current; }).slice(0, limit);
        jobs.push(loadCards(handles).then(function (cards) {
          cards.forEach(function (card) {
            var slide = document.createElement('div');
            slide.className = 'slider__slide';
            slide.appendChild(card);
            recentTarget.appendChild(slide);
          });
          if (!cards.length) {
            var msg = document.createElement('p');
            msg.className = 'tabs__empty';
            msg.textContent = T.strings.noRecent;
            recentTarget.closest('[data-slider]').replaceWith(msg);
          }
          return cards.length > 0;
        }));
      } else jobs.push(Promise.resolve(false));

      Promise.all(jobs).then(function (results) {
        var hasRelated = results[0];
        var hasRecent = results[1];
        if (!hasRelated && !hasRecent) { section.hidden = true; return; }
        if (relatedTarget && !hasRelated) {
          var tab = $('[data-tab^="related-"]', section);
          var panel = relatedTarget.closest('.tabs__panel');
          if (tab) tab.remove();
          if (panel) panel.remove();
          var recentTab = $('[data-tab^="recent-"]', section);
          if (recentTab) activateTab(recentTab);
        }
        initSliders(section);
        Wishlist.sync();
      });
    });
  }

  function activateTab(tab) {
    var wrap = tab.closest('[data-tabs]');
    $$('[data-tab]', wrap).forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      var panel = document.getElementById(t.getAttribute('data-tab'));
      if (panel) panel.classList.toggle('is-active', on);
    });
    initSliders(wrap);
  }

  /* ---------- Predictive search ---------- */
  function initPredictiveSearch() {
    var input = $('[data-predictive-search-input]');
    var results = $('[data-predictive-search-results]');
    if (!input || !results || !T.routes.predictiveSearch) return;
    var controller;
    input.addEventListener('input', debounce(function () {
      var q = input.value.trim();
      if (!q) { results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var url = T.routes.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,page,article&resources[limit]=6&section_id=predictive-search';
      fetchText(url, controller ? { signal: controller.signal } : {})
        .then(function (html) {
          var fresh = $('#PredictiveResults', parseHTML(html));
          results.innerHTML = fresh ? fresh.outerHTML : '';
        })
        .catch(function () { /* aborted or failed; keep previous results */ });
    }, 250));
  }

  /* ---------- Facets (filters & sorting) ---------- */
  var Facets = {
    section: function () { return $('[data-facets-section]'); },
    render: function (url, push) {
      var section = this.section();
      if (!section) { window.location.href = url; return; }
      var results = $('[data-facets-results]', section);
      results.classList.add('is-loading');
      var target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', section.getAttribute('data-section-id'));

      fetchText(target.toString()).then(function (html) {
        var fresh = $('[data-facets-results]', parseHTML(html));
        if (!fresh) throw new Error('empty');
        var openDrawer = Drawers.active && results.contains(Drawers.active) ? Drawers.active.getAttribute('data-drawer') : null;
        if (openDrawer) {
          var freshDrawer = $('[data-drawer="' + openDrawer + '"]', fresh);
          if (freshDrawer) {
            freshDrawer.style.transition = 'none';
            freshDrawer.classList.add('is-open');
            freshDrawer.setAttribute('aria-hidden', 'false');
          }
        }
        results.replaceWith(fresh);
        if (openDrawer) {
          var drawer = $('[data-drawer="' + openDrawer + '"]', fresh);
          if (drawer) {
            Drawers.active = drawer;
            requestAnimationFrame(function () { drawer.style.transition = ''; });
          } else Drawers.close();
        }
        var clean = new URL(url, window.location.origin);
        clean.searchParams.delete('section_id');
        if (push !== false) window.history.pushState({ facets: true }, '', clean.toString());
        Wishlist.sync();
      }).catch(function () { window.location.href = url; });
    },
    fromForm: function () {
      var section = this.section();
      var form = section ? $('[data-facets-form]', section) : null;
      var params = new URLSearchParams();
      if (form) {
        new FormData(form).forEach(function (value, key) { if (value !== '') params.append(key, value); });
      } else {
        params = new URLSearchParams(window.location.search);
        params.delete('page');
        var sort = section ? $('[data-facets-sort]', section) : null;
        if (sort) params.set('sort_by', sort.value);
      }
      this.render(window.location.pathname + '?' + params.toString());
    }
  };
  var facetsChanged = debounce(function () { Facets.fromForm(); }, 450);

  /* ---------- Announcement bar ---------- */
  function initAnnouncements(scope) {
    $$('[data-announcement]', scope).forEach(function (bar) {
      var items = $$('[data-announcement-item]', bar);
      if (bar.__timer) clearInterval(bar.__timer);
      if (items.length < 2) return;
      var i = 0;
      var interval = Number(bar.getAttribute('data-interval')) || 5000;
      bar.__timer = setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, interval);
    });
  }

  /* ---------- Header measurements ---------- */
  function measureHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var height = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--header-height', height + 'px');
    document.documentElement.style.setProperty('--header-sticky-height', header.classList.contains('header--sticky') ? height + 'px' : '0px');
  }

  /* ---------- Misc ---------- */
  function initAddressSelects(scope) {
    $$('select[data-default]', scope).forEach(function (select) {
      var value = select.getAttribute('data-default');
      if (value) select.value = value;
    });
  }

  function initAccountPanels() {
    if (window.location.hash === '#Recover') showAccountPanel('recover');
  }
  function showAccountPanel(name) {
    $$('[data-account-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-account-panel') !== name;
    });
  }

  /* ---------- Event delegation ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;

    if ((el = t.closest('[data-drawer-open]'))) {
      if (Drawers.open(el.getAttribute('data-drawer-open'))) e.preventDefault();
      return;
    }
    if (t.closest('[data-drawer-close]') || t.closest('[data-overlay]')) { Drawers.close(); return; }
    if (t.closest('[data-modal-close]')) { Modal.close(); return; }

    if ((el = t.closest('[data-quick-view]'))) { e.preventDefault(); openQuickView(el.getAttribute('data-quick-view')); return; }
    if ((el = t.closest('[data-wishlist-toggle]'))) { e.preventDefault(); Wishlist.toggle(el.getAttribute('data-wishlist-toggle')); return; }

    if ((el = t.closest('[data-cart-qty]'))) { e.preventDefault(); Cart.change(el.getAttribute('data-cart-qty'), el.getAttribute('data-qty-value')); return; }
    if ((el = t.closest('[data-cart-panel-open]'))) {
      var panel = $('[data-cart-panel="' + el.getAttribute('data-cart-panel-open') + '"]');
      if (panel) { panel.hidden = false; var field = $('textarea, input', panel); if (field) field.focus(); }
      return;
    }
    if ((el = t.closest('[data-cart-panel-close]'))) { el.closest('[data-cart-panel]').hidden = true; return; }
    if ((el = t.closest('[data-cart-note-save]'))) {
      var note = $('[data-cart-note]');
      el.classList.add('is-loading');
      Cart.saveNote(note ? note.value : '').then(function () {
        el.classList.remove('is-loading');
        el.closest('[data-cart-panel]').hidden = true;
      });
      return;
    }
    if ((el = t.closest('[data-cart-coupon-save]'))) {
      var scope = el.closest('[data-cart-panel], .cart-page__summary') || document;
      var coupon = $('[data-cart-coupon]', scope);
      el.classList.add('is-loading');
      Cart.applyCoupon(coupon ? coupon.value : '').then(function () { el.classList.remove('is-loading'); });
      return;
    }

    if ((el = t.closest('[data-qty-minus], [data-qty-plus]'))) {
      var input = $('[data-qty-input]', el.closest('.qty'));
      if (input) {
        var v = (parseInt(input.value, 10) || 1) + (el.hasAttribute('data-qty-plus') ? 1 : -1);
        input.value = Math.max(1, v);
      }
      return;
    }

    if ((el = t.closest('[data-gallery-thumb]'))) { Gallery.goTo(el.closest('[data-gallery]'), Number(el.getAttribute('data-gallery-thumb'))); return; }
    if ((el = t.closest('[data-gallery-prev], [data-gallery-next]'))) {
      var g = el.closest('[data-gallery]');
      Gallery.goTo(g, Gallery.index(g) + (el.hasAttribute('data-gallery-next') ? 1 : -1));
      return;
    }
    if ((el = t.closest('[data-lightbox-open]'))) { Lightbox.open(el.closest('[data-gallery]'), Number(el.getAttribute('data-lightbox-open'))); return; }
    if (t.closest('[data-lightbox-close]') || t.matches('.lightbox__image') || t.matches('.lightbox')) { Lightbox.close(); return; }
    if (t.closest('[data-lightbox-prev]')) { Lightbox.step(-1); return; }
    if (t.closest('[data-lightbox-next]')) { Lightbox.step(1); return; }

    if ((el = t.closest('[data-slider-prev], [data-slider-next]'))) { slideBy(el.closest('[data-slider]'), el.hasAttribute('data-slider-next') ? 1 : -1); return; }
    if ((el = t.closest('[data-slider-dot]'))) {
      var track = $('[data-slider-track]', el.closest('[data-slider]'));
      track.scrollTo({ left: Number(el.getAttribute('data-slider-dot')) * track.clientWidth, behavior: 'smooth' });
      return;
    }
    if ((el = t.closest('[data-tab]'))) { activateTab(el); return; }

    if ((el = t.closest('[data-sticky-add]'))) {
      var root = el.closest('[data-product]');
      var form = root && document.getElementById(root.getAttribute('data-form-id'));
      if (form) {
        if (form.requestSubmit) form.requestSubmit();
        else $('[type="submit"]', form).click();
      }
      return;
    }

    if ((el = t.closest('[data-facets-link]')) && Facets.section()) { e.preventDefault(); Facets.render(el.href); return; }
    if ((el = t.closest('[data-account-toggle]'))) { e.preventDefault(); showAccountPanel(el.getAttribute('data-account-toggle')); }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-product-form]')) { e.preventDefault(); Cart.add(form); return; }
    if (form.matches('[data-confirm]') && !window.confirm(form.getAttribute('data-confirm'))) { e.preventDefault(); return; }
    if (form.matches('[data-checkout-form]')) {
      var coupon = store.get('hs-coupon', '');
      if (coupon && !$('input[name="discount"]', form)) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'discount';
        hidden.value = coupon;
        form.appendChild(hidden);
      }
    }
    if (form.matches('[data-facets-form]')) { e.preventDefault(); Facets.fromForm(); }
  });

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-cart-qty-input]')) { Cart.change(t.getAttribute('data-cart-qty-input'), t.value); return; }
    if (t.closest('[data-localization-form]')) { t.closest('form').submit(); return; }
    if (t.closest('[data-facets-form]') || t.matches('[data-facets-sort]')) facetsChanged();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (Lightbox.el && Lightbox.el.classList.contains('is-open')) Lightbox.close();
      else if (Modal.active) Modal.close();
      else if (Drawers.active) Drawers.close();
    }
    if (Lightbox.el && Lightbox.el.classList.contains('is-open')) {
      if (e.key === 'ArrowLeft') Lightbox.step(-1);
      if (e.key === 'ArrowRight') Lightbox.step(1);
    }
  });

  window.addEventListener('popstate', function () {
    if (Facets.section()) Facets.render(window.location.href, false);
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) Cart.refresh();
  });

  /* ---------- Init ---------- */
  function initScope(scope) {
    initSliders(scope);
    Gallery.init(scope);
    initProducts(scope);
    initProductRecs(scope);
    initAnnouncements(scope);
    initAddressSelects(scope);
    Wishlist.sync();
  }

  trackRecentlyViewed();
  initScope(document);
  initPredictiveSearch();
  initAccountPanels();
  Wishlist.renderPage();
  measureHeader();
  window.addEventListener('resize', debounce(measureHeader, 150));

  document.addEventListener('shopify:section:load', function (e) {
    initScope(e.target);
    measureHeader();
    if (e.target.querySelector('[data-predictive-search-input]')) initPredictiveSearch();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (Drawers.active && e.target.contains(Drawers.active)) Drawers.close();
  });

  window.HamzaSelimTheme = { Cart: Cart, Drawers: Drawers, formatMoney: formatMoney };
})();
